// src/App.tsx - APLICACIÓN COMPLETA INFINITYWITS
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CartProvider } from './contexts/CartContext';
import { AuthProvider } from './contexts/AuthContext';

// Layout Components
import Header from './components/layout/Header';
import Navigation from './components/layout/TopBar';
import Footer from './components/layout/Footer';

// Pages
import Home from './pages/Home';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import ServiceList from './pages/ServiceList';
import ServiceDetail from './pages/ServiceDetail';
import CourseList from './pages/CourseList';
import CourseDetail from './pages/CourseDetail';
import MasterClass from './pages/MasterClass';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import About from './pages/About';
import Contact from './pages/Contact';

// Protected Route Component
import ProtectedRoute from './components/ProtectedRoute';

import './App.css';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <CartProvider>
          <Router>
            <div className="App min-h-screen flex flex-col">
              <Navigation />
              <main className="flex-grow">
                <Routes>
                  {/* Página principal */}
                  <Route path="/" element={<Home />} />
                  
                  {/* Productos */}
                  <Route path="/productos" element={<ProductList />} />
                  <Route path="/productos/:id" element={<ProductDetail />} />
                  
                  {/* Servicios */}
                  <Route path="/servicios" element={<ServiceList />} />
                  <Route path="/servicios/:id" element={<ServiceDetail />} />
                  
                  {/* Capacitaciones */}
                  <Route path="/capacitaciones" element={<CourseList />} />
                  <Route path="/capacitaciones/:id" element={<CourseDetail />} />
                  <Route path="/masterclass" element={<MasterClass />} />

                  {/* Nosotros */}
                  <Route path="/nosotros" element={<About />} />
                  <Route path="/nosotros/:id" element={<About />} />
                  
                  {/* Carrito y Checkout */}
                  <Route path="/carrito" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  
                  {/* Autenticación */}
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  
                  {/* Perfil (Protegido) */}
                  <Route 
                    path="/perfil" 
                    element={
                      <ProtectedRoute>
                        <Profile />
                      </ProtectedRoute>
                    } 
                  />
                  
                  {/* Páginas institucionales */}
                  <Route path="/nosotros" element={<About />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<ServiceList />} />
                  <Route path="/contacto" element={<Contact />} />
                  <Route path="/contact" element={<Contact />} />
                  
                  {/* 404 - Página no encontrada */}
                  <Route 
                    path="*" 
                    element={
                      <div className="min-h-screen flex items-center justify-center bg-gray-50">
                        <div className="text-center">
                          <h1 className="text-6xl font-bold text-gray-300 mb-4">404</h1>
                          <h2 className="text-2xl font-bold text-infinity-black mb-4">
                            Página no encontrada
                          </h2>
                          <p className="text-gray-600 mb-8">
                            La página que buscas no existe o ha sido movida.
                          </p>
                          <a 
                            href="/" 
                            className="btn-primary inline-block"
                          >
                            Volver al Inicio
                          </a>
                        </div>
                      </div>
                    } 
                  />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </CartProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;